import React from "react";

const Divider = ({ size = "2rem", color }) => (
  <div style={{ minHeight: size, width: "100%", background: color }} />
);

export default Divider;
